import request from '@/utils/request'

export function fetchUserList (query) {
  return request({
    url: '/auth/api/user/index',
    method: 'get',
    params: query
  })
}

export function fetchUser (id) {
  return request({
    url: '/auth/api/user/view',
    method: 'get',
    params: { id }
  })
}

export function createUser (data) {
  return request({
    url: '/auth/api/user/insert',
    method: 'post',
    data
  })
}

export function updateUser (data) {
  return request({
    url: '/auth/api/user/update',
    method: 'post',
    data
  })
}

export function deleteUser (id) {
  return request({
    url: '/auth/api/user/delete',
    method: 'post',
    params: { id }
  })
}

export function changePassword (data) {
  return request({
    url: '/auth/api/auth/changepassword',
    method: 'post',
    data
  })
}

export function fetchUserRoles (id) {
  return request({
    url: '/auth/api/user/roles',
    method: 'get',
    params: { id }
  })
}

export function updateUserRole (id, roles) {
  return request({
    url: '/auth/api/user/role_update',
    method: 'post',
    params: { id },
    data: { roles }
  })
}
export function ResetUserPassword (id) {
  return request({
    url: '/auth/api/user/resetPassword',
    method: 'post',
    params: { id }
  })
}



// WEBPACK FOOTER //
// ./src/api/user.js